<template>
  <SvgSprite />
  <QuickformTabs />
  <VDialog />
</template>

<script setup lang="ts">
import QuickformTabs from "./components/QuickformTabs.vue";
import { VDialog } from "v-ferry-components";
import SvgSprite from "@/components/icons/SvgSprite.vue";
</script>

<style lang="scss" scoped></style>
